import { Button, Grid, Skeleton, Typography } from '@mui/material'
import { Box, Container } from '@mui/system'
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import React, { useEffect, useState } from 'react'
import useAxiosPrivate from '../../hooks/use-axios-private';
import { humanFileSize } from '../../utils/basicUtils';
import { useTheme } from '@emotion/react';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 14,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === 'light' ? '#0B1345' : '#D0D1FF',
    },
}));


const Storage = () => {
    const theme = useTheme()
    const axios = useAxiosPrivate()
    const [storageConsumed, setStorageConsumed] = useState(false)
    const [showAlert, setShowAlert] = useState(false);
    const getStorage = async () => {

        try {
            let resp = await axios.get('jobs/storage/')
            setStorageConsumed(resp.data.data.storage_consumed)
            return resp

        }
        catch (e) {
            console.error("🚀 ~ file: Storage.jsx:38 ~ getStorage ~ e:", e)
            return false
        }
    }
    useEffect(() => {
        getStorage()
    }, [])


    return (
        <Box>
            <Container maxWidth="xl" sx={{ mb: 2 }}>
                <Box sx={{ mb: 1, mt: 3 }}>
                    <Typography sx={{ position: 'relative', pl: 1, fontSize: { xs: 20, md: 22, xl: 25 }, fontWeight: theme.palette.mode === "dark" ? '400' : '500', "&::after": { content: '""', position: 'absolute', background: '#f764a3', width: '3px', left: 0, top: '12.5%', bottom: '12.5%', borderRadius: 1 } }}>Storage</Typography>
                </Box>
                <Box>
                    <Grid container sx={{ marginTop: "0px", }}>
                        <Grid item xs={12} md={9} sx={{ pt: 0, }}>
                            <Box sx={{ boxShadow: "0px 0px 0px 3px #ebecf0", borderRadius: "6px", background: "#fff" }}>
                                <Box sx={{ mt: 2, p: { xs: 2, sm: 5, }, }}>
                                    <Box>
                                        <Box sx={{ background: "#ebecf0", width: "50px", height: "50px", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <FolderOpenOutlinedIcon color={"primary"} sx={{ fontSize: "28px", }} />
                                        </Box>
                                    </Box>
                                    <Box sx={{ mt: 2 }}>
                                        <Typography>Total Files</Typography>
                                    </Box>
                                    {
                                        storageConsumed
                                            ?
                                            <Box sx={{ mt: 2 }}>
                                                <Typography sx={{ fontSize: { xs: 18, sm: 22 }, fontWeight: 400, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>{storageConsumed.total_files_count || 0} Files</Typography>
                                            </Box>
                                            :
                                            <Box sx={{ width: "90px", mt: 4 }}>
                                                <Skeleton animation="wave" />
                                            </Box>
                                    }

                                    <Box sx={{ flexGrow: 1, mt: 1 }}>
                                        <BorderLinearProgress variant="determinate" value={((storageConsumed.total_consumed_size || 0) / ((1e+9) * 1)) * 100} />
                                    </Box>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1 }}>

                                        {
                                            storageConsumed
                                                ?
                                                <Box>
                                                    <Typography>{humanFileSize(storageConsumed.total_consumed_size || 0)}</Typography>
                                                </Box>
                                                :
                                                <Box sx={{ width: "90px" }}>
                                                    <Skeleton animation="wave" />
                                                </Box>
                                        }


                                        <Box>
                                            <Typography>1 GB</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                                {/* <Box>
                                    <Box sx={{ borderTop: "1px solid #bdc5db" }}></Box>
                                </Box> */}
                                {/* <Box sx={{ py: 2, px: { xs: 2, sm: 5, }, }}>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <Box>
                                            <Typography sx={{ fontSize: "18px" }}>View</Typography>
                                        </Box>
                                        <Box>
                                            <ArrowForwardIcon sx={{ fontSize: "22px", }} />
                                        </Box>
                                    </Box>
                                </Box> */}
                            </Box>
                            <Box sx={{ mt: 5, textAlign: "right" }}>
                                <Box>
                                    <Button variant="outlined" size="large" onClick={() => setShowAlert(true)}>Upgrade</Button>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Container >
        </Box >
    )
}

export default Storage